import { useEffect } from 'react';

import { useSnapshot } from 'valtio';

import {
  setGpsDataFiltered,
  setLinechartData,
  setSensorDataFiltered,
  store,
} from '../store';
import { zoomToGpsDataFiltered } from '../store/gpsData';

export const useFilterData = (mapRef: any) => {
  const { tsFilterRange } = useSnapshot(store);

  useEffect(() => {
    setSensorDataFiltered();
    setGpsDataFiltered();
    setLinechartData();
    zoomToGpsDataFiltered(mapRef);
  }, [tsFilterRange]);
};
